<template>
  <div class="ud-body">
    <!-- 搜索表单 -->
    <a-card :bordered="true">
      <a-form
        :model="where"
        :label-col="{ md: { span: 8 }, sm: { span: 24 } }"
        :wrapper-col="{ md: { span: 16 }, sm: { span: 24 } }"
      >
        <a-row>
          <a-col :lg="5" :md="12" :sm="24" :xs="24">
            <a-form-item label="充电柜编码:">
              <a-input
                v-model:value="where.cabinetCode"
                placeholder="请输入充电柜编码"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="12" :sm="24" :xs="24">
            <a-form-item label="所属运营商:">
              <a-select
                v-model:value="where.operatorId"
                placeholder="请选择所属运营商"
                @change="changeOperator"
                allow-clear
              >
                <a-select-option
                  v-for="item in operatorList"
                  :key="item.operatorId"
                  :value="item.operatorId"
                >
                  {{ item.operatorName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>          
          <a-col :lg="5" :md="12" :sm="24" :xs="24">
            <a-form-item label="型号:">
              <a-select
                v-model:value="where.model"
                placeholder="请选择型号"
                allow-clear
              >
                <a-select-option
                  v-for="item in modelList"
                  :key="item.brandId"
                  :value="item.model"
                >
                  {{ item.model }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="12" :sm="24" :xs="24">
            <a-form-item class="ud-text-right" :wrapper-col="{ span: 24 }">
              <a-space>
                <a-button type="primary" @click="reload">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <ud-pro-table
        ref="table"
        row-key="cabinetId"
        :datasource="datasource"
        :columns="columns"
        v-model:selection="selection"
        :scroll="{ x: 'max-content' }"
      >
        <!-- <template #pointName="{ record }">
          <router-link :to="'/zulin/pointLocation/index?id=' + record.pointId">
            {{ record.pointName }}
          </router-link>
        </template> -->
        <template #protocolType="{ record }">
          <span>
            {{ typeProtocol(record.protocolType) }}
          </span>
        </template>
        <template #toolbar>          
        </template>
        <template #enable="{ text, record }">
          <a-switch
            :checked="text === 0"
            @change="(checked) => editEnabled(checked, record)"
          />
        </template>
        <template #action="{ record }">
          <a-space>
            <a @click="openDetail(record)">详情</a>
            <a @click="openEdit(record)">修改</a>
          </a-space>
        </template>
      </ud-pro-table>
    </a-card>
    <!-- 编辑弹窗 -->
    <cabinet-edit v-model:visible="showEdit" :data="current" @done="reload" />
  </div>
  <!-- 详情弹窗 -->
  <cabinet-detail v-model:visible="showInfo" :data="current || {}" />
</template>

<script>
import * as chargeCabinetApi from '@/api/rnt/chargeCabinet'
import * as chargeCabinetModelApi from '@/api/rnt/chargeCabinetModel'
import * as operatorApi from '@/api/rnt/operator'
import cabinetDetail from './cabinet-detail.vue'
import cabinetEdit from './cabinet-edit.vue'
import { createVNode } from 'vue'
import {
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'

export default {
  name: 'chargeCabinetIndex',
  components: {
    cabinetEdit,
    cabinetDetail
  },
  data() {
    return {
      checked1: false,
      name: 'chargeCabinet',
      // 表格列配置
      columns: [
        {
          key: 'index',
          width: 48,
          customRender: ({ index }) => this.$refs.table.tableIndex + index
        },
        // 换电柜编码
        {
          title: '充电柜编码',
          dataIndex: 'cabinetCode',
          sorter: true
        },
        // 换电柜名称
        {
          title: '充电柜名称',
          dataIndex: 'cabinetName',
          sorter: true
        },
        // 型号
        {
          title: '型号',
          dataIndex: 'model',
          sorter: true
        },
        // 充电柜协议
        {
          title: '充电柜协议',
          dataIndex: 'protocolType',
          sorter: true
          // slots: { customRender: 'protocolType' }
        },
        // 运营商名称
        {
          title: '运营商名称',
          dataIndex: 'operatorName',
          sorter: true
        },
        // 所属租赁点名称
        {
          title: '所属租赁点名称',
          dataIndex: 'pointName',
          sorter: true
          // slots: { customRender: 'pointName' }
        },
        // 启用
        {
          title: '启用',
          dataIndex: 'enable',
          sorter: true,
          width: 90,
          align: 'center',
          slots: { customRender: 'enable' }
        },
        // 操作
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          slots: { customRender: 'action' }
        }
      ],
      // 运营商list
      operatorList: [],
      // 厂家list
      brandList: [],
      // 型号list
      modelList: [],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
      // 是否显示编辑弹窗
      showEdit: false,
      // 是否显示详情弹窗
      showInfo: false,
      // 当前编辑数据
      current: null,
      // 编辑表单提交状态
      editLoading: false
    }
  },
  mounted() {
    this.queryOperatorList()
    this.queryBrandList()
    this.queryModelList()
  },
  methods: {
    /* 修改用户状态 */
    editEnabled(checked, row) {
      const data = {
        enable: checked ? 0 : 1,
        cabinetId: row.cabinetId
      }
      chargeCabinetApi
        .enable(data)
        .then((res) => {
          if (res.code === 0) {
            row.enable = checked ? 0 : 1
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 详情 */
    openDetail(row) {
      this.current = row
      this.showInfo = true
    },
    // typeProtocol(protocolType) {
    //   if (protocolType === 45) {
    //     return '协议one'
    //   }
    //   if (protocolType === 46) {
    //     return '协议two'
    //   }
    // },
    datasource(option, callback) {
      chargeCabinetApi
        .page({
          ...this.where,
          page: option.page,
          limit: option.limit
        })
        .then((res) => {
          if (res.code === 0) {
            callback(res.data, res.count)
          } else {
            callback(res.msg)
          }
        })
        .catch((e) => {
          callback(e.message)
        })
    },
    /* 刷新表格 */
    reload() {
      this.selection = []
      this.$refs.table.reload({ page: 1 })
    },
    /* 重置搜索 */
    reset() {
      this.where = {}
      this.queryBrandList()
      this.queryModelList()
      this.$nextTick(() => {
        this.reload()
      })
    },
    /* 删除单个 */
    remove(row) {
      const hide = this.$message.loading('请求中..', 0)
      chargeCabinetApi
        .deleteById(row.cabinetId)
        .then((res) => {
          hide()
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.reload()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          hide()
          this.$message.error(e.message)
        })
    },
    /* 批量删除 */
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一条数据')
        return
      }
      this.$confirm({
        title: '提示',
        content: '确定要删除选中的项目吗?',
        icon: createVNode(ExclamationCircleOutlined),
        maskClosable: true,
        onOk: () => {
          const hide = this.$message.loading('请求中..', 0)
          const data = { data: this.selection.map((d) => d.cabinetId) }
          chargeCabinetApi
            .deleteBatch(data)
            .then((res) => {
              hide()
              if (res.code === 0) {
                this.$message.success(res.msg)
                this.reload()
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch((e) => {
              hide()
              this.$message.error(e.message)
            })
        }
      })
    },
    // 运营商改变获取对应品牌列表
    changeOperator(value) {
      this.where.brand = null
      this.where.model = null
      chargeCabinetModelApi
        .brand({ operatorId: value })
        .then((res) => {
          if (res.code === 0) {
            this.brandList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 查询所属运营商List */
    queryOperatorList() {
      operatorApi
        .all()
        .then((res) => {
          if (res.code === 0) {
            this.operatorList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 查询换电柜厂家List */
    queryBrandList() {
      chargeCabinetModelApi
        .brand()
        .then((res) => {
          if (res.code === 0) {
            this.brandList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 查询换电柜型号List */
    queryModelList() {
      chargeCabinetModelApi
        .model()
        .then((res) => {
          if (res.code === 0) {
            this.modelList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    // 监听厂家改变
    handleBrandChange(value) {
      this.where.model = null
      // 查找当前厂家充电柜型号
      chargeCabinetModelApi
        .model({ brandName: value, operatorId: this.where.operatorId })
        .then((res) => {
          if (res.code === 0) {
            this.modelList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 打开编辑弹窗 */
    openEdit(row) {
      this.current = row
      this.showEdit = true
    }
  }
}
</script>

<style scoped>
</style>
